import './App.css';
import './styles/mygamegroup.css';
import SiteNav from './components/partial/SiteNav';
import { useAuthStore } from './stores/useAuthStore';
import NotSignedIn from './components/NotSignedIn';
import MainPage from './components/MainPage';
import Loading from './components/partial/Loading';
import { useFirebaseAuth } from './hooks/useFirebaseAuth';
import { useGroupSummaryStore } from './stores/useGroupSummaryStore';
import { useCurrentGroupStore } from './stores/useCurrentGroupStore';
import { useCurrentGroupMembersStore } from './stores/useCurrentGroupMembersStore';
import { useLogGameStore } from './stores/useLogGameStore';

function App() {
  useFirebaseAuth();

  const isLoading = useAuthStore((state) => state.isAuthLoading);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  if (process.env.NODE_ENV === 'development') {
    window.authStore = useAuthStore;
    window.groupStore = useGroupSummaryStore;
    window.currentGroupStore = useCurrentGroupStore;
    window.groupMembersStore = useCurrentGroupMembersStore;
    window.logGameStore = useLogGameStore;
  }

  return (
    <>
      <SiteNav />
      <div className='container is-fullheight'>

        {isLoading ? <Loading /> : null}

        {!isLoading && !isAuthenticated ? <NotSignedIn /> : null}

        {!isLoading && isAuthenticated ? <MainPage /> : null}
      </div>
    </>
  );
}

export default App;
